import { MutableRecordStore } from '@deqo/foundation';
import { Path } from '../../../../platform/geom/Path';
import { Colors } from '../../../../ui';

const base = {
    adapter: ['none'] as Readonly<[string, Path?]>,
    imageUrl: null as string | null,
    label: '',
    color: Colors.primary,
    hat: '',
    x: 0,
    y: 0,
    opacity: 0,
    visible: false,
};

const overrides = {} as Partial<typeof base>;

export class Pawn extends MutableRecordStore({ ...base, overrides }) {
    constructor(public readonly id: string) {
        super();
    }
}
